import { Component, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { Router, NavigationStart } from '@angular/router';
import { CustomerVehiclePromotions, PromoDetails } from '@pos-app/data';
import { NgbInputDatepicker, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '@pos-app/core-ui/lib/services/api.service';
import { select, Store } from '@ngrx/store';
import { CoreUiPartialState, isExternalUser, isInternalUser } from '@pos-app/core-ui';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-community';
import { ClickAndCollectOrderGridActionRendererComponent } from '../../../orders/components/clickAndCollectOrderGridActionRenderer/clickAndCollectOrderGridActionRenderer.component';
import { CustomersPartialState } from '../../+state/customers.reducer';
import { FetchJdeOrder } from '../../../orders/+state/orders.actions';
import { CustomerPOSJobOrderGridActionRenderComponent } from '../../../orders/components/customerOrderGridActionrRenderer/customerPOSJobOrderGridActionRenderer.component';
import { getUserAssignedCurrencyFormat } from '@pos-app/core-ui/lib/utils/locale-helper';
import { saveLastEcomSearchResult } from '../../+state/customers.actions';
import { customersQuery } from '../../+state/customers.selectors';
import { CoreUiModule } from '../../../../../../../../libs/core-ui/src/lib/core-ui.module';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { AgGridModule } from 'ag-grid-angular';

@Component({
    selector: 'app-customers-ecom-search',
    templateUrl: './customers-ecom-search.component.html',
    styleUrls: ['./customers-ecom-search.component.scss'],
    imports: [CoreUiModule, FormsModule, NgIf, MatIcon, AgGridModule, AsyncPipe]
})
export class CustomersEcomSearchComponent implements OnInit {
  @ViewChild('searchBox') searchBox: any;
  private unSubscribe$ = new Subject<void>();
  searchString: string = '';
  gridOptions: GridOptions;
  columnDefs: ColDef[];
  frameworkComponents;
  context;
  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  searchValue: string;
  public loading$ = new BehaviorSubject<boolean>(false);
  rowData: [] = [];
  currencyCode: string;
  resultNotFound: boolean = false;

  constructor(
    private apiService: ApiService,
    private customerStore: Store<CustomersPartialState>,
    @Inject(LOCALE_ID) public locale: string,
    private router: Router
  ) {
    this.frameworkComponents = {
      actionRenderer: CustomerPOSJobOrderGridActionRenderComponent,
    };
    this.context = { componentParent: this };
    this.gridOptions = this.gridOptionsData();
  }

  ngOnInit(): void {
    this.searchBox?.nativeElement.focus();
    // Check if we're coming back from click-and-collect page with continueUrl=back
    const shouldClearData = sessionStorage.getItem('clearEcomSearchData') === 'true';

    if (shouldClearData) {
      this.rowData = [];
      this.customerStore.dispatch(new saveLastEcomSearchResult(this.rowData));
      // Clear the flag after using it
      sessionStorage.removeItem('clearEcomSearchData');
    } else {
      this.customerStore
        .select(customersQuery.getLastEcomSearchResult)
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((result) => {
          this.rowData = result;
        });
      sessionStorage.setItem('clearEcomSearchData', 'true');
    }
  }

  onClose() {}
  isFocus(event) {}
  lostFocus(event) {}
  onKeyboard(event) {}
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    const sortModel = [{ colId: 'dateTime', sort: 'desc' }];
  }
  gridOptionsData() {
    return {
      defaultColDef: {
        resizable: true,
        sortable: true,
        width: 150,
        cellClass: 'cell-class ag-right-aligned-cell',
        headerClass: 'header-class ag-left-aligned-header',
      },
      columnDefs: [
        {
          headerName: 'ACTION',
          width: 100,
          cellRenderer: 'actionRenderer',
          cellStyle: { 'text-align': 'center' },
        },
        {
          headerName: 'ORDER NO',
          width: 100,
          field: 'orderNumber',
          cellRenderer: (params) => this.createOrderLink(params),

          cellStyle: { 'text-align': 'right' },
        },
        {
          headerName: 'TYPE',
          width: 140,
          field: 'orderTypeDescription',
          cellStyle: { 'text-align': 'center' },
        },
        {
          headerName: 'REFERENCE',
          width: 100,
          field: 'reference',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'CUSTOMER NAME',
          width: 200,
          field: 'customerName',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'PHONE',
          width: 200,
          field: 'phone',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'EMAIL',
          width: 150,
          field: 'email',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'TOTAL VALUE',
          width: 150,
          field: 'totalPrice',
          cellRenderer: (params) => this.displayPrice(params.value, params.data.currencyCode),

          cellStyle: { 'text-align': 'left' },
        },

        {
          headerName: 'DISPATCH FROM',
          width: 150,
          field: 'dispatchFrom',
          cellStyle: { 'text-align': 'left' },
        },

        {
          headerName: 'CREATED DATE',
          width: 180,
          field: 'dateTime',
          valueFormatter: this.dateFormatter,
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'LAST CHANGED DATE',
          width: 180,
          field: 'dateTime',
          valueFormatter: this.dateFormatter,
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'REQUEST DATE',
          width: 180,
          field: 'dateTime',
          valueFormatter: this.dateFormatter,
          cellStyle: { 'text-align': 'left' },
        },
      ],
    };
  }

  displayPrice(price: number, currencyCode: string = ''): string {
    if (!price) {
      return '';
    }
    if (currencyCode !== '') {
      this.currencyCode = currencyCode;
    }
    return getUserAssignedCurrencyFormat(price, this.locale, this.currencyCode);
  }
  dateFormatter(params) {
    return moment(params.value).format('L <HH:mm>');
  }

  private createOrderLink(params): HTMLAnchorElement {
    const link = document.createElement('a');
    link.href = 'javascript:void(0)';
    link.innerText = params.value;
    link.addEventListener('click', () => {
      this.fetchOrderFromJDE(params.data);
    });
    return link;
  }

  fetchOrderFromJDE(data) {
    // Set a flag in sessionStorage to indicate we're navigating to click-and-collect with intent to come back
    sessionStorage.setItem('clearEcomSearchData', 'true');

    this.customerStore.dispatch(
      new FetchJdeOrder({
        orderNumber: data.orderNumber,
        orderType: data.orderType,
        JDEOrderType: data?.JDEOrderType,
        JDECompany: data?.JDECompany,
      })
    );
  }
  onSearch() {
    this.rowData = [];
    this.customerStore.dispatch(new saveLastEcomSearchResult(this.rowData));
    this.resultNotFound = false;
    this.loading$.next(true);
    this.apiService
      .globalEcomSearch({ searchString: this.searchString })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe({
        next: (res) => {
          this.loading$.next(false);
          this.rowData = res.quoteList || [];
          this.customerStore.dispatch(new saveLastEcomSearchResult(this.rowData));
        },
        error: () => {
          this.loading$.next(false);
        },
        complete: () => {
          this.loading$.next(false);
          this.searchString = '';
          this.resultNotFound = this.rowData?.length === 0;
          //focus on search input after search
          this.searchBox?.nativeElement.focus();
        },
      });

    if (!!this.rowData) {
      this.gridApi?.setRowData(this.rowData);
    }
  }
}

